/* Component Dependencies */
var hotelReviewDetailsTemplate = require('templates/hotelReviewDetails.hbs');
var AriesComponent = require('libs/aries-component');
var $ = require('jquery');
var pollUntil = require('utils/poll-until');

AriesComponent.create({
  type: 'hotelReviewDetails',
  template: {
    'hotelReviewDetails': hotelReviewDetailsTemplate
  },
  options: {
		POLL_TIMEOUT: 20000,
		POLL_INTERVAL: 1000
	},
  prevReviewCount: 0,
  bindEvents: function () {
    this.loadReviews();
  },
  getReviews: function () {
    $BV.configure('global', {});
    $BV.ui('rr', 'show_reviews', {
      productId: $('#BVRRContainer').data('product-id')
    })
    this.changeGSSSocialPropertyTextToResponseFromHotel();
  },
  addEventListenerToLoadMoreButton: function(_self) {
    if (document.querySelector("button.bv-content-btn-pages-load-more")) {
      document.querySelector("button.bv-content-btn-pages-load-more").addEventListener('click', function() {
        _self.changeGSSSocialPropertyTextToResponseFromHotel();
      })
    }
  },
  changeGSSSocialPropertyTextToResponseFromHotel: function () {
    var _self = this;
    let currentReviewCount = 0;
    pollUntil(function() {
        currentReviewCount = document.querySelectorAll("li.bv-content-top-review").length;
        if (currentReviewCount > _self.prevReviewCount) {
          const labelElement = document.querySelectorAll(".bv-content-reference-data.bv-content-author-name span.bv-author > span");
          labelElement.forEach(function (e) {
            if (e.innerHTML === "GSSSocialProperty" || e.innerHTML === "GSSSocialCompanyUser" || e.innerHTML === "GSSSocialPropertyReadOnly") {
              e.innerHTML = "Response From Hotel";
            }
          });
          if (document.querySelector(".bv-author-avatar-nickname button")) {
            const profileButtons = document.querySelectorAll(".bv-author-avatar-nickname button");
            profileButtons.forEach(function (e) {
              e.disabled = true;
            })
          }
          if (document.querySelector(".bv-content-reference-data.bv-content-author-name button.bv-author")) {
            const userButtons = document.querySelectorAll(".bv-content-reference-data.bv-content-author-name button.bv-author");
            userButtons.forEach(function (e) {
              e.disabled = true;
            })
          }
          $(".bv-section-summary .bv-section-summary-inline .bv-inline-histogram.bv-section-summary-block").remove();
          _self.addEventListenerToLoadMoreButton(_self);
          _self.prevReviewCount = currentReviewCount;
        }
      },
      [_self],
      _self.options.POLL_TIMEOUT,
      _self.options.POLL_INTERVAL)
  },
  loadReviews: function () {
    var _self = this;
    _self.makeAjaxCall({
      url: $('#BVRRContainer').data('reviews-endpoint'),
      dataType: 'script',
      crossDomain: true,
      skipRedirect: true,
      success: function () {
        _self.getReviews();
      }
    });
  }
});

